import { I18n } from '@calendly/i18n';
import { SwitchInput } from '@calendly/ui/components/switch-input';
import { TitleText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useEffect, useState, forwardRef } from 'react';
import { useGetFollowUpEmailPreferencesQuery, useUpdateFollowUpEmailPreferencesMutation } from 'features/crm';
const containerIsDesktopUpCss = "cfn0qso";
const containerCss = "c1v7owcg";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isDesktopUp = useDeviceType('isDesktopUp');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsDesktopUpCss]: isDesktopUp
  }, props.className)} />;
});
const sectionContentCss = "s1you4u7";
const SectionContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionContentCss, props.className)} />;
});
const switchContainerCss = "sk3ds26";
const SwitchContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(switchContainerCss, props.className)} />;
});
export const FollowUpEmailSection = () => {
  const {
    data,
    isLoading,
    isFetching
  } = useGetFollowUpEmailPreferencesQuery();
  const [updateFollowUpEmailPreferences, {
    isLoading: isUpdating
  }] = useUpdateFollowUpEmailPreferencesMutation();
  const [followUpEmailEnabled, setFollowUpEmailEnabled] = useState(null);
  useEffect(() => {
    const enabled = data?.followUpEmailPreferences?.enabled;
    if (enabled === undefined) return;
    setFollowUpEmailEnabled(enabled);
  }, [data]);
  const handleChange = async () => {
    if (followUpEmailEnabled === null) return;
    const newValue = !followUpEmailEnabled;
    try {
      await updateFollowUpEmailPreferences({
        enabled: newValue
      }).unwrap();
      setFollowUpEmailEnabled(newValue);
    } catch (error) {
      console.error('Failed to update setting:', error);
    }
  };
  const checked = !isLoading && followUpEmailEnabled === true;
  const toggleLabel = I18n.t('publisher.account_settings.communication_settings.recommended_follow_up_emails_toggle_label');
  return <Container>
      <SectionContent>
        <TitleText size="small">
          {I18n.t('publisher.account_settings.communication_settings.recommended_follow_up_emails')}
        </TitleText>
        <SwitchContainer>
          <label htmlFor="recommended-follow-up-emails-enabled">
            <SwitchInput id="recommended-follow-up-emails-enabled" checked={checked} onChange={() => handleChange()} disabled={isFetching || isUpdating} aria-label={toggleLabel} />
          </label>
          {toggleLabel}
        </SwitchContainer>
      </SectionContent>
    </Container>;
};

require("./follow_up_email_section.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./follow_up_email_section.js");